export var SystemEventLevel = /* @__PURE__ */ ((SystemEventLevel2) => {
  SystemEventLevel2["CRITICAL"] = "CRITICAL";
  SystemEventLevel2["ERROR"] = "ERROR";
  SystemEventLevel2["WARN"] = "WARN";
  SystemEventLevel2["INFO"] = "INFO";
  SystemEventLevel2["UNKNOWN"] = "UNKNOWN";
  return SystemEventLevel2;
})(SystemEventLevel || {});
export class SystemEvent {
  level;
  name;
  /**
   * Construct a new SystemEvent. This is a container for data marking a specific
   * event in your app. Ideally the name follows the enum pattern - all uppercase,
   * spaces replaced with underscores i.e. 'FETCH_ERROR'
   */
  constructor(level, name) {
    this.level = level;
    this.name = name;
  }
  /**
   * Get a string value of this event safe for Splunk.
   */
  toString() {
    return `SystemEvent(level=${this.level.toString()} name=${this.name})`;
  }
}
